import type { ReactNode } from "react";
import { I18nextProvider } from "react-i18next";

import i18n, { applyDocumentLocale } from "@/i18n";

applyDocumentLocale();

/**
 * Binds react-i18next to the shared i18n instance (ADR-076).
 *
 * Locale preference is read once at init from localStorage; changing it goes
 * through `setAppLocale` so the document `lang` and formatters stay aligned.
 */
export function LocaleProvider({ children }: { children: ReactNode }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
